import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';
import { addEventListener } from '@ifeng/ui_base';
import Ad from '@ifeng/ui_pc_ad';
import { rel } from '../../../../utils/rel';
import { getSkey } from '../../../../utils/utils';
import errorBoundary from '@ifeng/errorBoundary';

const LoadPPLive = Loadable({
    loader: () => import('./ppLive'),
    loading() {
        return <div />;
    },
});

class Affix extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isShow: false,
    };

    componentDidMount() {
        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    handleComment = () => {
        const { content } = this.props;
        const { title, commentUrl } = content;
        const skey = getSkey(title, commentUrl);

        window.open(`//gentie.ifeng.com/view.html?docUrl=${commentUrl}&docName=${title}&skey=${skey}`);
    };

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        if (currentTop > 100) {
            this.setState({ isShow: true });
        } else {
            this.setState({ isShow: false });
        }
    };

    /**
     * 回到顶部
     */
    backToTop = () => {
        scrollTo(0, 0);
    };

    /**
     * 渲染组件
     */
    render() {
        const { isShow } = this.state;
        const {
            content: { ppxAd, floatAd1 },
        } = this.props;

        const affix = (
            <React.Fragment>
                <div className={styles.affix_box}>
                    <div className={styles.bottom_affix}>
                        <a className={styles.backToHome} href="//www.ifeng.com/" />
                        <span className={styles.comment} onClick={this.handleComment} />
                        <a className={styles.feedback} href="//help.ifeng.com/" target="_blank" rel={rel} />
                        {isShow ? <span className={styles.backToTop} onClick={this.backToTop} /> : ''}
                    </div>
                </div>
                <Ad content={floatAd1} styleName={styles.floatAd} />
                {ppxAd && ppxAd.length > 0 ? <LoadPPLive tag="page_ppposiiton_live7" content={ppxAd} /> : ''}
            </React.Fragment>
        );

        return ReactDOM.createPortal(affix, document.body);
    }
}

export default errorBoundary(Affix);
